import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import {
  CcdlFooterComponent,
  CcdlSpinnerService,
  PlatformNameEnum,
  SpinnerOptions,
  SpinnerType,
} from '@cpm-pr1618001/ng-design-lib';
import { DashboardLabelsFacade } from '@cpm-pr1618003/ng-initializer-lib';
import {
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
} from 'rxjs';
import { InitFacade } from './store/facade/init.facade';
import { UserManagementFacade } from './store/user-management/facade/user-management.facade';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CcdlFooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  public readonly Platform_Name_Enum = PlatformNameEnum;
  isRouting = signal(true);

  constructor(
    private readonly router: Router,
    private readonly initFacade: InitFacade,
    private readonly dashboardLabelsFacade: DashboardLabelsFacade,
    private readonly userManagementFacade: UserManagementFacade,
    private readonly ccdlSpinnerService: CcdlSpinnerService,
  ) {
    const spinnerOptions: SpinnerOptions = {
      type: SpinnerType.DUAL_RING,
      spinnerText: 'Application loading...',
    };

    combineLatest([
      this.initFacade.isUserInfoLoaded$,
      this.dashboardLabelsFacade.isDisplayLabelsLoading$,
      this.userManagementFacade.initialUserManagementApiLoadingStatus$,
    ])
      .pipe(
        // Allow getUserSuccess effects to dispatch their follow-up API calls first.
        debounceTime(0),
        filter(([isUserInfoLoaded]) => isUserInfoLoaded),
        map(
          ([, isDisplayLabelsLoading, isUserManagementApiLoading]) =>
            isDisplayLabelsLoading || isUserManagementApiLoading,
        ),
        distinctUntilChanged(),
      )
      .subscribe((isLoading) => {
        this.isRouting.set(isLoading);
        if (isLoading) {
          this.ccdlSpinnerService.open(spinnerOptions);
        } else {
          this.ccdlSpinnerService.close();
        }
      });
  }
}
